<template>
  <section class="chat-window">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-md-12">
          <div class="card border-colorful">
            <div class="card-header d-flex justify-content-between align-items-center p-3">
              <h5 class="mb-0">Pixel Intelligence</h5>
              <div class="d-flex flex-row align-items-center">
                <i class="fas fa-minus me-3 text-muted fa-xs minimize" @click="toggleMinimize"></i>
              </div>
            </div>

            <div v-if="!isMinimized" class="card-body">
              <div v-for="(msg, index) in messages" :key="index">
                <!-- Mensagem do bot -->
                <div v-if="msg.from === 'bot'" class="d-flex flex-row justify-content-start">
                  <img src="/images/v2/layout/pixel-intelligence-icone.png" alt="bot" width="30" height="30">
                  <div class="position-relative">
                    <div
                      v-if="msg.loading"
                      class="bg-light ms-3 mb-3 rounded-3 w-100 p-10"
                    >
                      <Loader
                        :size="'small'"
                        :align="'start'"
                      />
                    </div>
                    <p
                      v-if="msg.text"
                      class="small p-2 ms-3 mb-3 rounded-3 bg-light"
                      v-html="msg.text"
                    >
                    </p>
                    <div v-if="msg.button">
                      <button @click="addAudiences" class="btn btn-xs btn-color10 py-2 ms-4">{{ $t('add_audiences') }}</button>
                    </div>
                  </div>
                </div>

                <!-- Mensagem do usuário -->
                <div v-else class="d-flex flex-row justify-content-end mb-4 pt-1">
                  <div>
                    <p class="small p-2 me-3 mb-3 text-black rounded-3 bg-warning">
                      {{ msg.text }}
                    </p>
                  </div>
                  <img src="/images/v2/layout/blank.png" alt="user" width="30" height="30" class="rounded-circle">
                </div>
              </div>
            </div>

            <div v-if="!isMinimized" class="card-footer text-muted d-flex flex-column justify-content-start align-items-center p-3">
              <div class="input-group mb-0">
                <input
                  type="text"
                  class="form-control"
                  v-model="newMessage"
                  :placeholder="$t('enter2')"
                  @keyup.enter="sendMessage"
                />
                <button class="btn btn-color10" type="button" @click="sendMessage">
                  {{ $t('send') }}
                </button>
              </div>
              <small class="mt-3 text-end">{{ $t('review_AI_generated_content') }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import IaAgentService from '@/modules/integrations/services/ai-agent-service'
import { marked } from 'marked'

import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'AudienceSuggestionAgent',
  components: {
    Loader
  },
  data () {
    return {
      isMinimized: false,
      newMessage: '',
      messages: [
        { from: 'bot', text: this.$t('welcome_suggested_audiences') }
      ],
      audiences: []
    }
  },
  watch: {
    audiences (newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.messages.push({
          from: 'bot',
          text: this.$t('can_we_add_these_suggested_audiences'),
          button: true
        })
      }
    }
  },
  methods: {
    /**
     * Add audiences
     */
    addAudiences () {
      this.$emit('audiences', this.audiences)
    },
    /**
     * send message
     */
    async sendMessage () {
      const content = this.newMessage.trim()
      if (!content) return

      this.messages.push({ from: 'user', text: content })
      this.newMessage = ''

      // Mensagem de carregamento
      const loadingIndex = this.messages.length
      this.messages.push({ from: 'bot', text: '', loading: true })

      try {
        const res = await IaAgentService.askQuestions({
          message: content
        })

        // Substituir mensagem de loading
        this.$set(this.messages, loadingIndex, {
          from: 'bot',
          text: marked(res.response.content) || this.$t('try_again_later'),
          loading: false
        })

        if (res.response.metadata.length > 0) {
          this.audiences = res.response.metadata[0]
        }
      } catch (err) {
        this.$set(this.messages, loadingIndex, {
          from: 'bot',
          text: this.$t('error_communicating_with_server'),
          loading: false
        })
      }
    },
    /**
     * toogle minimize
     */
    toggleMinimize () {
      this.isMinimized = !this.isMinimized
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-window {
  width: 100%;

  .card {
    border-radius: 10px;
  }
  .card-header {
    min-height: 40px;
  }
  .card-body {
    padding: 2rem 1.5rem;
    position: relative;
    height: 300px;
    overflow-y: auto;
  }
}
.minimize {
  cursor: pointer;
}

</style>
